import reducer from './client.reducer';

export default reducer;
